import { DIRS } from "../../utils/constants"

export const isUp = key => key === "ArrowUp" || key === "w"
export const isDown = key => key === "ArrowDown" || key === "s"
export const isLeft = key => key === "ArrowLeft" || key === "a"
export const isRight = key => key === "ArrowRight" || key === "d"
export const isConfirm = key => key === "Enter" || key === "Spacebar"
export const isCancel = key => key === "Escape"
export const getDirection = key => {
  if(isUp(key)) return DIRS.UP
  if(isDown(key)) return DIRS.DOWN
  if(isLeft(key)) return DIRS.LEFT
  if(isRight(key)) return DIRS.RIGHT
}